// Create a "show password" toggle on password fields

// Get all password fields
const pwds = document.querySelectorAll('input[type="password"]');

const templateResetPassword = document.querySelector(
  '.template-reset_password',
);

if (pwds) {
  pwds.forEach((pwd) => {
    // console.log(pwd);

    const container = pwd.parentNode;
    container.style.position = 'relative';

    // create containing div for styles
    const div = document.createElement('div');
    div.setAttribute('id', 'tglpwd');
    div.style.cssText = `
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 12px;
      height: ${pwd.offsetHeight}px;
      justify-content: center;
      line-height: 1;
      position: absolute;
      right: 0px;
      top: 0px;
      width: ${pwd.offsetHeight}px;
      text-indent: -9999rem;
      background: transparent url('https://cdn.shopify.com/s/files/1/0257/2756/5890/files/icon-eyes.png?v=1628101746') no-repeat center center / 40%;
    `;

    // append p to div
    div.append('Show');

    if (templateResetPassword) {
      // create wrapper container
      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';

      // insert wrapper before el in the DOM tree
      pwd.parentNode.insertBefore(wrapper, pwd);

      // move el into wrapper
      wrapper.appendChild(pwd);

      // move id div to within new wrapper
      wrapper.append(div);
    } else {
      // append div to parent container of the password input
      container.append(div);
    }

    // toggle show/hide password
    function togglePsswrd() {
      if (pwd.type === 'password') {
        pwd.type = 'text';
      } else {
        pwd.type = 'password';
      }
    }

    // toggle hide/show text
    function toggleHideShow() {
      if (div.innerHTML === 'Show') {
        div.style.background =
          "#fcf5f5 url('https://cdn.shopify.com/s/files/1/0257/2756/5890/files/icon-eyes.png?v=1628101746') no-repeat center center / 40%";
        div.innerHTML = 'Hide';
      } else {
        div.style.background =
          "transparent url('https://cdn.shopify.com/s/files/1/0257/2756/5890/files/icon-eyes.png?v=1628101746') no-repeat center center / 40%";
        div.innerHTML = 'Show';
      }
    }

    // check body clicks for the element (delegated)
    document.body.addEventListener('click', (event) => {
      if (event.target.id === 'tglpwd') {
        togglePsswrd();
        toggleHideShow();
      }
    });
  });
}
